export default "__VITE_ASSET__296ce9f8__"